export const clearSearchParams = (key: string) => {
  const searchParams = new URLSearchParams(window.location.search);
  searchParams.delete(key);
  const newPath = window.location.pathname + '?' + searchParams.toString();
  window.history.replaceState({}, '', newPath);
};
